<app-dashboard-sidemenu></app-dashboard-sidemenu>

<!-- Start Main Content Wrapper Area -->
<div class="main-content d-flex flex-column">

    <app-dashboard-navbar></app-dashboard-navbar>

    <!-- Breadcrumb Area -->
    <div class="breadcrumb-area" *ngFor="let Content of breadcrumb;">
        <h1>{{Content.title}}</h1>
        <ol class="breadcrumb">
            <li class="item"><a routerLink="/">Home</a></li>
            <li class="item"><a routerLink="dashboard">{{Content.subTitle}}</a></li>
            <li class="item">{{Content.title}}</li>
        </ol>
    </div>
    <!-- End Breadcrumb Area -->

    <!-- Start -->
    <!-- End -->

    <!-- Start Dialog -->
    <p-dialog [(visible)]="showRegistrationBanner" [modal]="true" [style]="{width: '50vw', 'border-radius': '20px'}"
        [contentStyle]="{'overflow-y': 'hidden'}"
        [closable]="false" [showHeader]="false" [dismissableMask]="false">
        <div style="padding: 25px; font-size: 15px; line-height: 1.5; color: #333;">
            <h4
                style="color: #d9534f; font-weight: bold; margin-bottom: 15px; border-bottom: 1px solid #eee; padding-bottom: 10px;">
                Important Information</h4>
            <p style="margin-bottom: 10px;"><strong>Dear User,</strong></p>
            <p style="margin-bottom: 15px;">As part of our ongoing system improvements, the Customer Registration Portal is being migrated to a new
                URL. Please review the important dates below and ensure that all pending requests are completed before
                the current portal is decommissioned.</p>
            <h5 style="font-weight: 600; margin-bottom: 10px;">Key Dates:</h5>
            <ul style="list-style-type: disc; padding-left: 20px; margin-bottom: 15px;">
                <li style="margin-bottom: 6px;"><strong>Current Portal Deactivation:</strong> 17 August 2026 at 12:00 AM
                    onwards. Please ensure all open requests are closed before this time.</li>
                <li style="margin-bottom: 6px;"><strong>Portal Shutdown Date:</strong> 17 August 2026</li>
                <li style="margin-bottom: 6px;"><strong>New Portal Login Details:</strong> 17 August 2026. Login
                    credentials and access details for the new portal will be shared on this date.</li>
                <li style="margin-bottom: 6px;"><strong>New Portal Go-Live Date:</strong> 18 August 2026</li>
                <li style="margin-bottom: 6px;"><strong>New Portal URL:</strong> <a
                        href="https://myidexhub.idexasia.com/authentication/side-login" target="_blank"
                        style="color: #007bff; text-decoration: underline;">https://myidexhub.idexasia.com/authentication/side-login</a>
                </li>
            </ul>
            <p style="margin-bottom: 20px; font-weight: 500;">We appreciate your cooperation and support during this
                transition.</p>
            <div style="text-align: right;">
                <button type="button" class="btn btn-secondary"
                    style="padding: 8px 30px; font-weight: 600; border-radius: 5px; cursor: pointer;"
                    (click)="closeBanner()">Close</button>
            </div>
        </div>
    </p-dialog>
    <!-- End Dialog -->

    <!-- Start -->
    <div class="row">
        <div class="col-lg-6 col-md-12">
            <div class="my-profile-box">
                <h3>Profile Details ({{localStorageObject.roleName}})</h3>

                <form>
                    <div class="row">
                        <div class="col-lg-12 col-md-12">
                            <div class="form-group">
                                <label>Your Name</label>
                                <input type="text" readonly class="form-control"
                                    [value]="this.supplierProfile[0]?.name">
                            </div>
                        </div>

                        <div class="col-xl-6 col-lg-12 col-md-12">
                            <div class="form-group">
                                <label>Email</label>
                                <input type="email" readonly class="form-control"
                                    [value]="this.supplierProfile[0]?.emailAddress">
                            </div>
                        </div>

                        <div class="col-xl-6 col-lg-12 col-md-12">
                            <div class="form-group">
                                <label>Phone</label>
                                <input type="text" readonly class="form-control"
                                    [value]="this.supplierProfile[0]?.mobileNo">
                            </div>
                        </div>

                        <div class="col-xl-6 col-lg-12 col-md-12">
                            <div class="form-group">
                                <label>Address</label>
                                <input type="text" readonly class="form-control"
                                    [value]="this.supplierProfile[0]?.address">
                            </div>
                        </div>
                    </div>
                    <div class="row" *ngIf="this.localStorageObject.roleName == 'Supplier'">
                        <div class="notification-alert-profile alert alert-success alert-dismissible fade show"
                            role="alert" *ngIf="this.supplierProfile[0]?.isApproved == 'Rework'">
                            Your Status is in <strong>Rework</strong> State , Please Update Details ! <br>
                            Action : {{this.supplierProfile[0]?.isApprovedRemark}}
                            &nbsp;<span style="cursor: pointer; text-decoration: underline;"
                                routerLink="/supplierMaster"> Go</span>
                        </div>
                        <div class="notification-alert-profile alert alert-success alert-dismissible fade show"
                            role="alert"
                            *ngIf="this.supplierProfile[0]?.isApproved != 'Rework' && this.supplierProfile[0]?.isApproved != ''">
                            Thank you for Registered with us ! <br>
                            <!-- Your Status is <strong>{{this.supplierProfile[0]?.isApproved}}</strong> -->
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <div class="col-lg-6 col-md-12">
            <div class="my-profile-box">
                <h3>Change Password</h3>

                <form [formGroup]="changePasswordFormControl" (ngSubmit)="changePassword(signin)" #signin="ngForm">
                    <div class="row">
                        <div class="col-lg-12 col-md-12">
                            <div class="form-group">
                                <label>Current Password <span class="star_class">*</span></label>
                                <input type="password" class="form-control" (blur)="checkForPassword()"
                                    formControlName="loginPassword" [class.is-invalid]="signin.submitted &&
                                changePasswordFormControl.get('loginPassword')?.invalid" required>
                                <div class="invalid-feedback">
                                    Enter Current Password
                                </div>
                                <div class="error-msg" *ngIf="samePasswordError.length>0">{{samePasswordError}}</div>
                            </div>
                        </div>

                        <div class="col-lg-12 col-md-12">
                            <div class="form-group">
                                <label>New Password <span class="star_class">*</span></label>
                                <input type="password" class="form-control" (blur)="checkForPassword()"
                                    formControlName="password"
                                    [class.is-invalid]="signin.submitted &&
                                changePasswordFormControl.get('password')?.invalid || (changePasswordFormControl.get('password')?.invalid && changePasswordFormControl.get('password')?.touched)"
                                    [(ngModel)]="password" required>
                                <div class="invalid-feedback">
                                    Enter New Password
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-12 col-md-12">
                            <div class="form-group">
                                <label>Confirm New Password <span class="star_class">*</span></label>
                                <input type="password" class="form-control" (blur)="checkForPassword()"
                                    formControlName="confirmPassword"
                                    [class.is-invalid]="signin.submitted &&
                                changePasswordFormControl.get('confirmPassword')?.invalid || (changePasswordFormControl.get('confirmPassword')?.invalid && changePasswordFormControl.get('confirmPassword')?.touched)"
                                    [(ngModel)]="confirmPassword" required>
                                <div class="invalid-feedback">
                                    Enter New Confirm Password
                                </div>
                                <h6 class="text-danger" *ngIf="confirmPassword">
                                    {{ password === "" && confirmPassword != "" ?
                                    "Enter password" : "" }} {{ password != ""
                                    && password != confirmPassword ? "Password Not Match" : "" }} {{password ==
                                    confirmPassword && password.length < 8 ? "Enter Password atleast 8 characters" : ""
                                        }} </h6>
                            </div>
                        </div>

                        <div class="col-lg-12 col-md-12">
                            <div class="form-group">
                                <button type="submit">Change Password</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <!-- End -->

    <div class="flex-grow-1"></div>

    <app-copyrights></app-copyrights>

</div>
<!-- End Main Content Wrapper Area -->